import script from "./AllAnsweredPrayers.vue?vue&type=script&setup=true&lang=js"
export * from "./AllAnsweredPrayers.vue?vue&type=script&setup=true&lang=js"

import "./AllAnsweredPrayers.vue?vue&type=style&index=0&id=ebdeae70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebdeae70"]])

export default __exports__